import { render, staticRenderFns } from "./SpecBudgetPopupWrappable.vue?vue&type=template&id=fdd64ed2&scoped=true&lang=pug&"
import script from "./SpecBudgetPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecBudgetPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecBudgetPopupWrappable.vue?vue&type=style&index=0&id=fdd64ed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd64ed2",
  null
  
)

export default component.exports